<template>
  <div v-if="filtered">
    <v-data-table
      :hide-default-footer="hideFooter"
      :headers="headers ? headers : originHeaders"
      mobile-breakpoint="0"
      :items="hideFooter ? studentDetailAttendances : studentCheckins"
      item-key="id"
      loading-text="Đang Tải"
      :loading="loading"
      :footer-props="footerTable"
    >
      <!-- Học sinh -->
      <template #item.student="{ item }">
        <CardStudentName :student="item.student" link />
      </template>
      <!-- Ngày sinh -->
      <template #item.dob="{ item }">
        <span>{{ (item.student && item.student.dob) | ddmmyyyy }}</span>
      </template>
      <!-- Ngày -->
      <template #item.date="{ item }">
        {{ item.time | ddmmyyyy }}
      </template>
      <!-- Lớp -->
      <template #item.class="{ item }">
        <router-link
          style="text-decoration: none"
          :to="'/class/' + (item.student.currentClass && item.student.currentClass.id)"
        >
          <span v-if="item.student.currentClass">{{
            item.student.currentClass && item.student.currentClass.title
          }}</span>
        </router-link>
      </template>
      <!-- Giờ đến / Giờ về -->
      <template #item.time="{ item }">
        <div v-if="item.checkinObjects && item.checkinObjects.length">
          <div class="pt-2" style="height: 36px" v-for="checkinObject in item.checkinObjects" :key="checkinObject.id">
            {{ checkinObject.checkIn | hhmm }} / {{ checkinObject.checkOut | hhmm }}
          </div>
        </div>
        <div v-else>--:-- / --:--</div>
      </template>
      <!-- Trạng thái -->
      <template #item.status="{ item }">
        <div v-if="item.checkinObjects && item.checkinObjects.length">
          <div v-for="checkinObject in item.checkinObjects" :key="checkinObject.id" class="pt-2" style="height: 36px">
            <v-chip small label :color="checkinObject.status | getAttendanceStatusColor" dark>
              <span>
                {{ checkinObject.status | getAttendanceStatus }}
              </span>
            </v-chip>
          </div>
        </div>
        <div v-else>
          <v-chip small label color="#FD6B6B" dark>
            <span> Chưa điểm danh </span>
          </v-chip>
        </div>
      </template>
      <!-- Thao tác -->
      <template #item.action="{ item }">
        <div v-if="item.checkinObjects && item.checkinObjects.length">
          <div v-for="checkinObject in item.checkinObjects" :key="checkinObject.id">
            <AttendanceListActions
              :student="item.student"
              :checkinObject="checkinObject"
              @attendanceUpdated="refresh(searchParams)"
            />
          </div>
        </div>
        <div v-else>
          <AttendanceListActions
            :student="item.student"
            :checkinObject="{}"
            @attendanceUpdated="refresh(searchParams)"
          />
        </div>
      </template>
    </v-data-table>
  </div>
  <div v-else class="d-flex flex-column align-center justify-center mx-md-4 my-md-4 elevation-0 py-16">
    Vui lòng cung cấp các thông tin ở trên, sau đó ấn [Tìm kiếm] để kiểm tra trạng thái điểm danh
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters, mapState } from 'vuex'
import AttendanceListActions from '@/modules/attendance/AttendanceListActions'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'

export default {
  components: { AttendanceListActions, CardStudentName },
  data() {
    return {
      filtered: false,
      originHeaders: [
        { text: 'Học sinh', value: 'student', width: 200, sortable: true },
        {
          text: 'Ngày sinh',
          value: 'dob',
          width: 100,
          sortable: false
        },
        { text: 'Lớp', value: 'class', width: 100, sortable: false },
        {
          text: 'Giờ đến / Giờ về',
          value: 'time',
          sortable: false,
          align: 'left',
          width: 150
        },
        { text: 'Trạng thái', value: 'status', sortable: false, align: 'center' },
        { text: 'Thao tác', value: 'action', width: 100, sortable: false }
      ]
      // attendances: [
      //   { date: '28/01/2021', time: '08:00 / 17:00', type: 'onTime' },
      //   { date: '29/01/2021', time: '09:00 / 17:00', type: 'late' },
      //   { date: '30/01/2021', time: '08:00 / 17:00', type: 'onTime' }
      // ]
    }
  },
  props: {
    hideFooter: { type: Boolean, default: () => false },
    headers: { type: Array, default: () => null },
    student: { type: Object, default: () => {} }
  },
  computed: {
    ...mapState('attendance', ['studentCheckins', 'searchParams', 'loading', 'studentDetailAttendances']),
    ...mapGetters('attendance', ['attendances']),
    ...mapState('attendance', ['date']),
    ...mapGetters('auth', ['ownClassIds']),

    footerTable() {
      let footer = {
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'items-per-page-options': [5, 10, 15]
      }

      return footer
    }
  },
  methods: {
    ...mapActions('attendance', [
      'searchAttendances',
      'requestPageSettings',
      'fetchStudentAttendances',
      'getAttendanceStudents',
      'fetchAttendancesInStudentDetail'
    ]),
    async refresh(query) {
      this.filtered = true
      // const start = moment()
      //   .startOf('day')
      //   .toISOString()
      // const end = moment()
      //   .endOf('day')
      //   .toISOString()
      // const params = { time_gte: start, time_lte: end }
      // await this.searchAttendances({ ...query })
      // await this.fetchStudentAttendances({ ...query, time: this.date })

      // await this.searchAttendances({ ...query })

      if (this.hideFooter && this.student.id) {
        this.fetchAttendancesInStudentDetail({
          student: this.student.id,
          _sort: 'time:desc',
          _limit: 5
        })
      } else {
        query = {
          ...query,
          time_gte: moment(query.time)
            .startOf('day')
            .toISOString(),
          time_lte: moment(query.time)
            .endOf('day')
            .toISOString()
        }

        const params = { ...query }
        // teacher
        if (this.ownClassIds) params['currentClass_in'] = this.ownClassIds
        await this.getAttendanceStudents(params)
      }
    },

    formatTime(time, str) {
      return moment(time).format(str)
    },
    handleClick(data) {
      this.$emit('handleClick', data)
    },
    getColor(s) {
      if (s === 'late') return 'orange'
      else return '#46BE8A'
    },
    evenNumbers(item) {
      if (item.attendance) {
        return [...Array(item.attendance.checkin.length)].map((_, i) => i).filter(i => i % 2 === 0)
      }
      return [0]
    }
    // getCheckIn(item) {
    //   let time = ''
    //   for (let i = 0; i < item.checkin.length; i += 2) {
    //     time += `<div>${item.checkin[i] || `-:-`}</div><br/>`
    //   }
    //   return time
    // },
    // getCheckOut(item) {
    //   let time = ''
    //   for (let i = 1; i < item.checkin.length + 1; i += 2) {
    //     time += `<div>${item.checkin[i] || `-:-`}</div><br/>`
    //   }
    //   return time
    // }
  },
  filters: {
    // getAttendanceStatus(attendance) {
    //   if (attendance) {
    //     if (attendance.status === 'attendance') return 'Có mặt'
    //     if (attendance.status === 'left') return 'Đã rời trường'
    //   }
    //   return 'Chưa điểm danh'
    // },
    // getAttendanceStatusColor(attendance) {
    //   if (attendance) {
    //     if (attendance.status === 'attendance') return '#46BE8A'
    //     if (attendance.status === 'left') return 'orange'
    //   }
    //   return '#FD6B6B'
    // }
  },
  watch: {}
}
</script>

<style scoped></style>
